import { createSlice } from '@reduxjs/toolkit';

import { SLICE_BASE_NAME } from './constant';

export interface SessionState {
    signedIn: boolean;
    accessToken: string | null;
    refreshToken: string | null;
}

const authLocalStorage = JSON.parse(localStorage.getItem('auth') || '{}');

const initialState: SessionState = {
    signedIn: authLocalStorage?.accessToken ? true : false,
    accessToken: authLocalStorage?.accessToken
        ? authLocalStorage?.accessToken
        : null,
    refreshToken: authLocalStorage?.refreshToken
        ? authLocalStorage?.refreshToken
        : null,
};

const sessionSlice = createSlice({
    name: `${SLICE_BASE_NAME}/session`,
    initialState,
    reducers: {
        signInSuccess(state, action) {
            state.signedIn = true;
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
        },
        signOutSuccess(state) {
            state.signedIn = false;
            state.accessToken = null;
            state.refreshToken = null;
        },
    },
});

export const { signInSuccess, signOutSuccess } = sessionSlice.actions;
export default sessionSlice.reducer;
